import proptypes from 'prop-types';

const { string } = proptypes;

export const propTypesEmtQuestionsAndAnswers = {
  nValue: string
};
